export enum DocumentType {
  RECORD_OF_VEHICLE_OPERATION = 'RECORD_OF_VEHICLE_OPERATION',
  ATTENDANCE_STATEMENT = 'ATTENDANCE_STATEMENT',
}
